module.exports = __webpack_public_path__ + "static/media/casePanel.e650b58b.svg";